import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { OrderCompleteComponent } from './pages/order-complete/order-complete.component';
import { OrderSummaryComponent } from './pages/order-summary/order-summary.component';
import { ProofOfIdentityComponent } from './pages/proof-of-identity/proof-of-identity.component';
import { ScoreReportComponent } from './pages/score-report/score-report.component';
import { RegistrationComponent } from './registration.component';
import { PhotoUploadComponent } from './pages/photo-upload/photo-upload.component';
import { ScannedDocumentUploadComponent } from './pages/scanned-document-upload/scanned-document-upload.component';
import { StudyMaterialsComponent } from './pages/study-materials/study-materials.component';
import { BatchRegistrationSelectAccountsComponent } from './pages/business-account/batch-registration-select-accounts/batch-registration-select-accounts.component';
import { BatchRegistrationSelectSittingComponent } from './pages/business-account/batch-registration-select-sitting/batch-registration-select-sitting.component';
import { BatchRegistrationSelectTestComponent } from './pages/business-account/batch-registration-select-test/batch-registration-select-test.component';
import { TestSummaryComponent } from './pages/test-summary/test-summary.component';
import { SittingSelectionWebDeliveryComponent } from './pages/sitting-selection-web-delivery/sitting-selection-web-delivery.component';
import { SittingSelectionComponent } from './pages/sitting-selection/sitting-selection.component';
import { TestSelectionComponent } from './pages/test-selection/test-selection.component';
import { NavigationRoute } from '../core/constants/constants';
import { BiometricConsentComponent } from './pages/biometric-consent/biometric-consent.component';
import { TestRegistrationReceiptComponent } from './pages/order-complete/test-registration-receipt/test-registration-receipt.component';

const regPaths = NavigationRoute.REGISTRATION;

const routes: Routes = [
  {
    path: 'registration',
    component: RegistrationComponent,
    children: [
      {
        path: regPaths.testSelection,
        component: TestSelectionComponent
      },
      {
        path: regPaths.testSelectionWebDelivery,
        component: TestSelectionComponent
      },
      {
        path: regPaths.sittingSelection,
        component: SittingSelectionComponent
      },
      {
        path: regPaths.sittingSelectionWebDelivery,
        component: SittingSelectionWebDeliveryComponent
      },
      {
        path: regPaths.proofOfIdentity,
        component: ProofOfIdentityComponent
      },
      {
        path: regPaths.biometricConsent,
        component: BiometricConsentComponent
      },
      {
        path: regPaths.photoUpload,
        component: PhotoUploadComponent
      },
      {
        path: regPaths.scannedDocumentUpload,
        component: ScannedDocumentUploadComponent
      },
      {
        path: regPaths.scoreReport,
        component: ScoreReportComponent
      },
      {
        path: regPaths.testSummary,
        component: TestSummaryComponent
      },
      {
        path: regPaths.studyMaterials,
        component: StudyMaterialsComponent
      },
      {
        path: regPaths.orderSummary,
        component: OrderSummaryComponent
      },
      {
        path: regPaths.orderComplete,
        component: OrderCompleteComponent,
      },
      {
        path: 'test-registration-receipt',
        component: TestRegistrationReceiptComponent
      }
    ]
  },
  {
    path: 'batch-registration',
    children: [
      {
        path: regPaths.testSelection,
        component: BatchRegistrationSelectTestComponent
      },
      {
        path: regPaths.sittingSelection,
        component: BatchRegistrationSelectSittingComponent
      },
      {
        path: regPaths.accountSelection,
        component: BatchRegistrationSelectAccountsComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class RegistrationRoutingModule { }
